import React from 'react'
import PropTypes from 'prop-types'
import ContactsFilter from './ContactsFilter'
import ConversionStats from './ConversionStats'

const Header = ({
  onFilterChange,
  filterValue,
  conversionStats,
}) => (
  <div className="contactsHeader">
    <ContactsFilter
      onChange={onFilterChange}
      value={filterValue}
    />
    <ConversionStats
      conversionStats={conversionStats}
    />
  </div>
)

Header.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
  filterValue: PropTypes.string.isRequired,
  conversionStats: PropTypes.object.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactsTab/Header.js